
import {

} from 'vuex'
import Vue from 'vue'
import XButton from 'vux/src/components/x-button/index.vue'

Vue.component('x-button', XButton)

export default {
name: 'app',
provide() {
return {
reload: this.reload
}
},
components: {},
computed: {

},
data() {
return {
isRouterAlive: true
}
},
methods: {
reload() {
this.isRouterAlive = false;
this.$nextTick(function () {
this.isRouterAlive = true;
});
}
},
}



// WEBPACK FOOTER //
// ./src/App.vue